import { useMemo } from 'react';
import { useAuthStore } from '@stores/auth.store';

/**
 * Returns whether the current user profile is a client (for tab label overrides, etc.).
 */
export function useIsClientProfile() {
    const user = useAuthStore((s) => s.user);
    const role = useAuthStore((s) => s.role);
    return useMemo(
        () =>
            user?.isClient === true ||
            (typeof role === 'string' && role.toLowerCase() === 'client') ||
            (typeof user?.role === 'string' && user?.role.toLowerCase() === 'client') ||
            (Array.isArray(user?.roles) && user.roles.some((r) => String(r).toLowerCase() === 'client')),
        [user, role]
    );
}
